// Initialize I18n for JavaScript
import { I18n } from 'i18n-js';

// Module-level variable to hold the configured instance
let currentI18nInstance = null;

// Helper function to get the base locale (e.g., 'nl' from 'nl-NL')
function getBaseLocale(locale) {
  if (!locale) return null;
  return locale.split('-')[0];
}

function initializeI18n() {
  const allTranslations = window.I18nTranslations || {};

  if (Object.keys(allTranslations).length === 0) {
    // console.warn('[lib/config/i18n] WARNING: window.I18nTranslations is empty or not found. Translations will not work correctly. Ensure it is set in your HTML layout before this script runs, and that your `javascript_translations` helper in Rails is providing data.');
  }

  const i18nInstance = new I18n(allTranslations); // Create new instance

  // Configure default locale and fallback behavior
  i18nInstance.defaultLocale = 'en'; // Set your application's default language
  i18nInstance.enableFallback = true; // Fallback to defaultLocale if a translation is missing in the current locale

  // Function to determine and set the active locale for i18n-js
  function setLocale() {
    const htmlLang = document.documentElement.lang; // e.g., "en", "nl", "nl-NL"

    if (htmlLang) {
      const baseLocale = getBaseLocale(htmlLang);
      i18nInstance.locale = baseLocale;
    } else {
      i18nInstance.locale = i18nInstance.defaultLocale;
    }
  }

  // Initialize the locale immediately when this module is first loaded
  setLocale();

  // Listen for Turbo navigations to re-apply locale settings if needed,
  // though html lang typically doesn't change without a full page reload.
  document.addEventListener('turbo:load', () => {
    setLocale();
  });

  // Assign to module-level variable and window
  currentI18nInstance = i18nInstance;
  window.I18n = currentI18nInstance; // Keep for global access if other scripts need it
}

// Initial setup
initializeI18n();

// Export the module-level instance, aliased as i18n
export { currentI18nInstance as i18n };